import { Menu, Bell, Search } from "lucide-react";
import { getAuth } from "firebase/auth";

const AdminTopbar = ({ setOpen, role = "Admin" }) => {
  const auth = getAuth();
  const user = auth.currentUser;

  return (
    <header className="sticky top-0 z-30 flex h-[72px] items-center justify-between border-b border-sand-200 bg-white/85 px-4 backdrop-blur-xl lg:px-6">
      <div className="flex items-center gap-3">
        <button
          onClick={() => setOpen(true)}
          className="btn-icon h-10 w-10 lg:hidden"
          aria-label="Open menu"
        >
          <Menu size={18} />
        </button>

        <div className="hidden lg:flex items-center gap-2">
          <div className="input-group h-11 min-w-[280px]">
            <Search size={16} className="text-ink-400" />
            <input placeholder="Search admin panel..." />
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <button className="btn-icon relative h-10 w-10" aria-label="Notifications">
          <Bell size={17} />
          <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-rose-500" />
        </button>

        <div className="flex items-center gap-3">
          {user?.photoURL ? (
            <img
              src={user.photoURL}
              alt="Admin"
              className="h-10 w-10 rounded-full object-cover object-center ring-1 ring-sand-200"
            />
          ) : (
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-gradient font-bold text-white shadow-soft">
              {user?.email?.charAt(0)?.toUpperCase() || "A"}
            </div>
          )}
          <div className="hidden lg:block leading-tight">
            <p className="text-[13px] font-semibold text-ink-800">
              {user?.email?.split("@")[0] || "Admin"}
            </p>
            <p className="text-[11px] font-semibold capitalize tracking-wide text-ink-400">{role}</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminTopbar;
